import { render, staticRenderFns } from "./MeusPontosPage.vue?vue&type=template&id=6feb4ff5&scoped=true"
import script from "./MeusPontosPage.vue?vue&type=script&lang=js"
export * from "./MeusPontosPage.vue?vue&type=script&lang=js"
import style0 from "./MeusPontosPage.vue?vue&type=style&index=0&id=6feb4ff5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feb4ff5",
  null
  
)

export default component.exports